import { AuthProviderProps } from 'Auth/shared/models/Context'
import { WebStorageStateStore } from 'oidc-client-ts'
import { isLocalhost } from 'shared/utils/isLocalhost'
import {
  LOCALSTORAGE_IDENTITY_PREFIX,
  LOCAL_STORAGE_CLIENT_ID,
  LOCAL_STORAGE_REDIRECT_URL,
} from '../../../shared/constants/localStorageVariables'

const bblCode = window.config.bblCode
const bblidUrl = window.config.urls.bblidBaseUrl + 'host/core'
const appUrl = window.location.origin + (!isLocalhost ? '/portal' : '')

const client = window.clientConfigs?.find(
  (x) => x.BblCode.toLowerCase() === bblCode.toLowerCase()
)

export const oidcConfig: AuthProviderProps = {
  onBeforeSignIn: () => {
    localStorage.setItem(LOCAL_STORAGE_REDIRECT_URL, window.location.href)
  },

  onSignIn: () => {
    const redirectUri = localStorage.getItem(LOCAL_STORAGE_REDIRECT_URL)

    localStorage.removeItem(LOCAL_STORAGE_REDIRECT_URL)
    window.location.replace(redirectUri ?? '/')
  },

  onSignOut: () => {
    localStorage.removeItem(LOCAL_STORAGE_CLIENT_ID)
    localStorage.removeItem(
      `${LOCALSTORAGE_IDENTITY_PREFIX}user:${oidcConfig.authority}:${oidcConfig.client_id}`
    )
  },

  revokeTokenTypes: ['refresh_token'],
  automaticSilentRenew: true,
  authority: bblidUrl,
  client_id: client?.ClientId || '',
  redirect_uri: appUrl + '/signin-oidc',
  post_logout_redirect_uri: appUrl + '/afterlogout',
  response_type: 'code',
  loadUserInfo: false,
  scope: 'openid api offline_access profile bbl',
  response_mode: 'query',
  revokeAccessTokenOnSignout: true,
  client_secret: 'UCGNFrp2rPJ4KPiiw48hxVZeFy5w8ETn',
  userStore: new WebStorageStateStore({
    store: localStorage,
    prefix: LOCALSTORAGE_IDENTITY_PREFIX,
  }),
}
